import { useSelector } from './';
import { hasRole } from 'store/Auth';

export default function useRole(role) {
  const rolesList = role ? (Array.isArray(role) ? role : [role]) : [];
  const isAllowed = useSelector(hasRole(rolesList));

  return isAllowed;
}